import { Component, type ReactNode } from 'react';
import { MessageScreen } from '../features/auth/screens';

interface Props {
  children: ReactNode;
  /** Called once per caught render error, e.g. to report it (roadmap P0-5). */
  onError?: (error: Error) => void;
  reload?: () => void;
}

/** A render error shows «Перезапустить» instead of a blank Telegram window. */
export class ErrorBoundary extends Component<Props, { failed: boolean }> {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error: Error) {
    this.props.onError?.(error);
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <MessageScreen
        title="Что-то пошло не так"
        text="Приложение столкнулось с ошибкой. Перезапустите его — данные не потеряются."
        onRetry={this.props.reload ?? (() => window.location.reload())}
      />
    );
  }
}
